var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"realNameAuthentication h-100 bg-gray"},[_c('div',{staticClass:"box step"},[_c('step',{attrs:{"steps":_vm.steps,"active":_vm.active}})],1),(_vm.active===0)?_c('personal-form',{on:{"next":_vm.next}}):(_vm.active===1)?_c('realName-form',{on:{"next":_vm.next}}):(_vm.active===2)?_c('live-form',{on:{"next":_vm.next}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }